import { useImmer } from "use-immer";
import Map from "../../components/Map/Map";

const MapInstall = ({ setMapInstall, data }) => {
  const [selectedItems, setSelectedItems] = useImmer([]);

  const updateSelection = (newSelectedItems, type) => {
    let exclusionList = data
      .filter((x) => x.pendingDistribution)
      .map((x) => x.qubyId);
    newSelectedItems = newSelectedItems.filter(
      (x) => !exclusionList.includes(x)
    );
    if (type === "select") {
      setSelectedItems(newSelectedItems);
    }
    if (type === "add") {
      setSelectedItems(
        Array.from(new Set([...selectedItems, ...newSelectedItems]))
      );
    }
    if (type === "remove") {
      setSelectedItems(
        selectedItems.filter((item) => !newSelectedItems.includes(item))
      );
    }
  };

  return (
    <div className="custom-container">
      <div
        style={{
          gap: "12px",
          marginTop: "20px",
        }}
        className="row"
      >
        <div
          style={{
            position: "relative",
          }}
          className="col-5 card"
        >
          <div
            style={{
              display: "flex",
              gap: "24px",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <div
              onClick={() => setMapInstall(false)}
              style={{
                backgroundColor: "#fff",
                padding: "12px 24px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                cursor: "pointer",
                transition: "background-color 0.3s, transform 0.3s",
                color: "#000",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#fff")}
            >
              <p style={{ margin: 0 }}>Installed List</p>
            </div>

            <div
              onClick={() => setMapInstall(true)}
              style={{
                backgroundColor: "#fff",
                padding: "12px 24px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                cursor: "pointer",
                transition: "background-color 0.3s, transform 0.3s",
                color: "#000",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#fff")}
            >
              <p style={{ margin: 0 }}>Installed Locations on Map</p>
            </div>
          </div>
          <div className="background-dataTable mt-4">
            <ul>
              {data.map((item) => (
                <li
                  key={item.qubyId}
                  onClick={() => {
                    setMapInstall(true);
                    updateSelection([item.qubyId], "select");
                  }}
                  style={{
                    cursor: "pointer",
                    padding: "8px",
                    border: "1px solid #ddd",
                    marginBottom: "8px",
                  }}
                >
                  {item.installCity} - {item.installationAddress}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="col-6">
          <Map
            data={data}
            onSelect={updateSelection}
            selectedItems={selectedItems}
          />
        </div>
      </div>
    </div>
  );
};

export default MapInstall;
